import React from "react";
import PropTypes from "prop-types";
import { Box, ListItemButton, IconButton, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import TaxRegimeInfo from "../../components/tax/TaxRegimeInfo.component";
import UserAppBarComponent from "../../components/user/user.appbar.component";

const SidebarFooter = ({
  open,
  selectedMenu,
  selectedSubmenu,
  handleLogout,
  handleNavigateToTaxes,
  user,
  isLoading,
  theme,
  setOpenProfile,
}) => {
  return (
    <Box
      sx={{
        p: 2,
        pb: 3, // Padding inferior maior para mobile
        display: "flex",
        flexDirection: "column",
        gap: 2,
        borderTop: "1px solid rgba(255, 112, 67, 0.1)",
        background: "linear-gradient(180deg, transparent 0%, rgba(255, 112, 67, 0.02) 100%)",
        backdropFilter: "blur(10px)",
      }}
    >
      <Box
        sx={{
          display:
            selectedMenu === 1 && selectedSubmenu === 0 ? "flex" : "none",
          justifyContent: open ? "flex-start" : "center",
          width: "100%",
        }}
      >
        <TaxRegimeInfo open={open} onConfigureClick={handleNavigateToTaxes} />
      </Box>

      <UserAppBarComponent
        open={open}
        onAction={setOpenProfile}
        user={user}
        isLoading={isLoading}
      />

      {open ? (
        <ListItemButton
          onClick={handleLogout}
          sx={{
            borderRadius: "12px",
            background: "linear-gradient(135deg, rgba(244, 67, 54, 0.05) 0%, rgba(244, 67, 54, 0.02) 100%)",
            border: "1px solid rgba(244, 67, 54, 0.1)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              background: "linear-gradient(135deg, rgba(244, 67, 54, 0.1) 0%, rgba(244, 67, 54, 0.05) 100%)",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 12px rgba(244, 67, 54, 0.15)",
              borderColor: "rgba(244, 67, 54, 0.2)",
            },
          }}
        >
          <LogoutIcon
            sx={{
              color: "#f44336",
              marginRight: "12px",
              transition: "transform 0.3s ease",
            }}
          />
          <Typography
            sx={{
              color: "#f44336",
              fontWeight: 600,
              fontSize: "0.95rem",
            }}
          >
            Sair
          </Typography>
        </ListItemButton>
      ) : (
        <IconButton
          onClick={handleLogout}
          sx={{
            padding: "12px",
            borderRadius: "12px",
            background: "linear-gradient(135deg, rgba(244, 67, 54, 0.05) 0%, rgba(244, 67, 54, 0.02) 100%)",
            border: "1px solid rgba(244, 67, 54, 0.1)",
            color: "#f44336",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              background: "linear-gradient(135deg, rgba(244, 67, 54, 0.1) 0%, rgba(244, 67, 54, 0.05) 100%)",
              transform: "scale(1.05)",
              boxShadow: "0 4px 12px rgba(244, 67, 54, 0.15)",
              borderColor: "rgba(244, 67, 54, 0.2)",
            },
          }}
        >
          <LogoutIcon />
        </IconButton>
      )}
    </Box>
  );
};

SidebarFooter.propTypes = {
  open: PropTypes.bool.isRequired,
  selectedMenu: PropTypes.number.isRequired,
  selectedSubmenu: PropTypes.number,
  handleLogout: PropTypes.func.isRequired,
  handleNavigateToTaxes: PropTypes.func.isRequired,
  user: PropTypes.object,
  isLoading: PropTypes.bool,
  theme: PropTypes.object.isRequired,
  setOpenProfile: PropTypes.func.isRequired,
};

export default SidebarFooter;
